import {
  EMPTY_ERROR,
  LOGOUT,
  SET_LOADING,
  GET_HEALTH_INSURANCE_SUCCESS,
  GET_HEALTH_INSURANCE_FAILURE,
  SAVE_HEALTH_INSURANCE
} from './types';

const initialState = {
  healthInsurances: [],
  healthInsurance: null,
  error: null,
  isLoading: false,
};

const healthInsuranceReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_HEALTH_INSURANCE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        healthInsurances: action.payload,
        error: null,

      };
    case GET_HEALTH_INSURANCE_FAILURE:
      return {
        ...state,
        healthInsurance: null,
        isLoading: false,
        error: action.payload.response.data.error,
      };
    case SAVE_HEALTH_INSURANCE:
      return {
        ...state,
        healthInsurance: action.payload
      };
    case EMPTY_ERROR:
      return {
        ...state,
        error: null,
      };
    case SET_LOADING:
      return {
        ...state,
        isLoading: true
      };
    case LOGOUT:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default healthInsuranceReducer;
